import { useLayoutEffect } from 'react'
import useToggle from './useToggle'

export const scrollLockToggle = (
    lock,
    element = document.documentElement,
    className = 'scroll-lock'
) => {
    const isScrollLockForce = window.navigator.userAgent.match(/iphone|ipad/i)
        && element === document.documentElement

    const forceScrollY = isScrollLockForce
        && (lock
            ? window.scrollY
            : parseInt(document.body.style.top || '0') * -1)

    if ((lock
                && !element.classList.contains(className))
            || (!lock
                && element.classList.contains(className)))
        element.classList[lock ? 'add' : 'remove'](className)

    if ((lock
                && !element.style.overflow)
            || (!lock
                && element.style.overflow))
        element.style.overflow = lock
            ? 'hidden'
            : ''

    if (!isScrollLockForce)
        return

    element.classList.add(`${className}-force`)

    if (lock) {
        document.body.style.position = 'fixed'
        document.body.style.top = `-${forceScrollY}px`
    }

    if (!lock) {
        document.body.style.position = ''
        document.body.style.top = ''

        window.scrollTo({
            left: 0,
            top: forceScrollY,
            behavior: 'auto'
        })
    }

    element.classList.remove(`${className}-force`)
}

export default function useScrollLockToggle (
    initialState = false,
    element = document.documentElement,
    className = 'scroll-lock'
) {
    const [lock, toggleLock] = useToggle(Boolean(initialState))

    useLayoutEffect(() =>
        scrollLockToggle(lock, element, className), [lock])

    return [lock, toggleLock]
}
